import { Component, OnInit, Output, Input, ViewChild, EventEmitter, TemplateRef, AfterViewInit, ChangeDetectorRef, Optional, LOCALE_ID, Inject } from '@angular/core';
import { DataTableComponent } from '@farris/ui-datatable';
import { TypeConverter } from '@farris/ide-property-panel';
import { HttpService } from '@ecp-caf/caf-common';
import { DatagridComponent } from '@farris/ui-datagrid';
import { MessagerService } from '@farris/ui-messager';
import { WF_LANG_RESOURCES, WfLocalePipe } from '../../i18n/pipe/wf-process-editor-locale.pipe';
import { WF_PROCESS_EDITOR_LANG_RESOURCES } from '../../i18n/assets/lang.resource';

@Component({
  selector: 'app-entry-form-editor',
  templateUrl: './entry-form-editor.component.html',
  styleUrls: ['./entry-form-editor.component.css'],
  providers: [
     WfLocalePipe,
  ]
})
export class EntryFormEditorComponent implements OnInit, AfterViewInit {

  @Output() closeModal = new EventEmitter<any>();
  @Output() submitModal = new EventEmitter<any>();

  @Input()
  set value(data: any) {
    if (data) {
      this.flowFormId = data.id;
    }
  }

  @ViewChild('iconSelectFooter') modalFooter: TemplateRef<any>;

  @ViewChild('grid') grid: DatagridComponent;

  @Input() editorParams: any = {};

  private flowFormId: string;
  modalConfig = {
    title: this.localePipe.transform('component.entryFormEditor.flowForm'),
    width: 760,
    height: 506,
    showButtons: true
  };

  columns = [
    { title: this.localePipe.transform('component.entryFormEditor.code'), field: 'code', width: 100, sortable: true },
    { title: this.localePipe.transform('component.entryFormEditor.name'), field: 'name', width: 100, sortable: true },
    { title: this.localePipe.transform('component.entryFormEditor.base'), field: 'base', width: 60,
    formatter: { type: 'boolean', options: { trueText: this.localePipe.transform('component.entryFormEditor.foundation'), falseText: this.localePipe.transform('component.entryFormEditor.extend')  } }}
  ];

  data = [];

  constructor(
    private http: HttpService,
    private message: MessagerService,
    @Optional() private cdr: ChangeDetectorRef,
    @Inject(LOCALE_ID) private localeId: string,
    @Inject(WF_LANG_RESOURCES) private resources: any,
    @Optional() private localePipe: WfLocalePipe,
  ) {
    this.localePipe = this.localePipe || new WfLocalePipe(localeId, resources);
   }

  ngOnInit() {
    this.getBaseAndExtendFlowForm();
  }
  ngAfterViewInit() {
  }

  clickOK() {
    if (!this.grid.selectedRow) {
      this.message.info(this.localePipe.transform('component.entryFormEditor.selectedRow'));
      return;
    }
    const object = { value: this.grid.selectedRow.data, parameters: null };
    this.submitModal.emit(object);
  }

  clickCancel() {
    this.closeModal.emit();
  }

  private getBaseAndExtendFlowForm() {
    if (this.flowFormId) {
      const url = `/api/runtime/wf/v1.0/flowForm/${this.flowFormId}/baseAndExtend`;
      this.http.get(url).subscribe((re: any) => {
        if (re && re.length > 0) {
          this.data = re;
          setTimeout(() => {
            this.grid.selectRow(this.flowFormId, true);
          }, 0);
        } else {
          this.message.info(this.localePipe.transform('component.entryFormEditor.absent'));
        }
      });
    }
  }

}
export class FlowFormConverter implements TypeConverter {
  constructor() { }

  convertTo(data): string {
    if (data) {
      return data.name;
    }
  }
}




